var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowMoodRainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 153,
    viewBox: "0 0 294 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 52V85",
    stroke: "#9F99D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164 55V79",
    stroke: "#9F99D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67V84",
    stroke: "#9F99D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184 84V100",
    stroke: "#9F99D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224 48V59",
    stroke: "#9F99D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207 48V54",
    stroke: "#9F99D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132 68V106",
    stroke: "#9F99D9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 62.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 95.5039,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 86.5039,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 46.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 37.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 55.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 79.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 97.5,
    r: 1,
    fill: "#9F99D9",
    stroke: "#9F99D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowMoodRainIcon);
export default __webpack_public_path__ + "static/media/lowMoodRainIcon.5ee80246bc1d72117ffa56ffe8e62f55.svg";
export { ForwardRef as ReactComponent };